import React from "react";
import { Col, Row } from "react-bootstrap";
import { useMediaQuery } from "../../../hooks";
import { Spacer } from "../../spacer";

interface PortalBookingStepLayoutProps {
  leftContent: JSX.Element;
  rightContent: JSX.Element;
}

export function PortalBookingStepLayout({
  leftContent,
  rightContent,
}: PortalBookingStepLayoutProps) {
  const { device } = useMediaQuery();

  if (device === "mobile") {
    return (
      <div>
        {leftContent}
        <Spacer size={24} />
        {rightContent}
      </div>
    );
  }

  return (
    <Row>
      <Col>{leftContent}</Col>
      <Col>{rightContent}</Col>
    </Row>
  );
}
